<ng-container
  *ngIf="bankProposalData.bankProposalStatisticsForMaturities && bankProposalData.bankProposalStatisticsForMaturities.length > 0;else noData">
  <div class="card-header">
    <div class="grid-x">
      <div class="cell auto">
        <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">{{"widget.name.".concat(widget.widgetName) | translate}}</h4>
      </div>
      <div class="cell shrink">
      </div>
    </div>
  </div>
  <div class="card-body vertical-center" style="overflow: visible">

    <div class="d-block padding-h-s">
    <table class="tableau_jdo margin-reset expanded separated condensed medium">
      <thead class="condensed">
      <tr>
        <th id="header-maturities" class="text-center border-reset">

        </th>
        <th id="header-fixed-rate" class="jdo-headertauxfixe" colspan="2" style="border-bottom:0;">
          <h6><strong>{{'widget.bank-proposal.large.fixed' | translate}}</strong><span [attr.data-balloon]="'widget.bank-proposal.fixedRateInformation' | translate" data-balloon-length="medium" data-balloon-pos="down"><span class="fa fa-info-circle margin-l-xs"></span></span></h6>
        </th>
        <th id="header-floating-rate" class="jdo-headertauxvariable" colspan="2" style="border-bottom:0;">
          <h6><strong>{{'widget.bank-proposal.large.floating' | translate}}</strong><span [attr.data-balloon]="'widget.bank-proposal.floatingRateInformation' | translate" data-balloon-length="medium" data-balloon-pos="down"><span class="fa fa-info-circle margin-l-xs"></span></span></h6>
        </th>
      </tr>
      <tr>
        <th id="maturities" class="text-center">

        </th>
        <th id="header-fixed-rate-best" class="jdo-headertauxfixe font-normal">
          {{'widget.bank-proposal.large.best' | translate}}
        </th>
        <th id="header-fixed-rate-avg" class="jdo-headertauxfixe font-normal" style="border-left:0;">
          {{'widget.bank-proposal.large.avg' | translate}}
        </th>
        <th id="header-floating-rate-best" class="jdo-headertauxvariable font-normal">
          {{'widget.bank-proposal.large.best' | translate}}
        </th>
        <th id="header-floating-rate-avg" class="jdo-headertauxvariable font-normal" style="border-left:0;">
          {{'widget.bank-proposal.large.avg' | translate}}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let jdoDataLine of bankProposalData.bankProposalStatisticsForMaturities" style="height:22px;">
        <th id="maturity" class="c-default bg-very-light-gray">
          <div class="i-block padding-v-xs">{{jdoDataLine.maturity}} A</div>
        </th>
        <td class="jdo-contenttauxfixe">
          <span
            [title]="displayDifferential(jdoDataLine.bestFixedRate, jdoDataLine.bestFixedRatePrevious)"
            class="fas {{resolveTrend(jdoDataLine.bestFixedRate, jdoDataLine.bestFixedRatePrevious)}}"></span>
          <b> {{displayRate(jdoDataLine.bestFixedRate)}}</b>
        </td>
        <td class="jdo-contenttauxfixe" style="border-left:0">
          <span
            [title]="displayDifferential(jdoDataLine.avgFixedRate, jdoDataLine.avgFixedRatePrevious)"
            class="fas {{resolveTrend(jdoDataLine.avgFixedRate, jdoDataLine.avgFixedRatePrevious)}}"></span> {{displayRate(jdoDataLine.avgFixedRate)}}
        </td>
        <td class="jdo-contenttauxvariable">
          <span [title]="displayDifferential(jdoDataLine.bestFloatingMarge, jdoDataLine.bestFloatingMargePrevious)"
                class="fas {{resolveTrend(jdoDataLine.bestFloatingMarge , jdoDataLine.bestFloatingMargePrevious)}}"></span>
          <b> {{displayRate(jdoDataLine.bestFloatingMarge)}}</b>
        </td>
        <td class="jdo-contenttauxvariable" style="border-left:0">
          <span
            [title]="displayDifferential(jdoDataLine.avgFloatingMarge, jdoDataLine.avgFloatingMargePrevious)"
            class="fas {{resolveTrend(jdoDataLine.avgFloatingMarge, jdoDataLine.avgFloatingMargePrevious)}}"></span> {{displayRate(jdoDataLine.avgFloatingMarge)}}
        </td>
      </tr>
      </tbody>
    </table>
    </div>
  </div>
  <div class="card-footer">
    <a *ngIf="isAssistanceEnabled" (click)="redirectToAssistance()" class="button insito">
      <span
        [title]="'widget.bank-proposal.discover-opportunity' | translate">{{'widget.bank-proposal.discover-opportunity' | translate}}</span>
    </a>
    <a *ngIf="!isAssistanceEnabled" (click)="redirectToInsitoIfHasAccessOrElseBankProposal()" class="button insito">
      <span *ngIf="insitoAccountId !== undefined" [title]="'widget.bank-proposal.discover-opportunity' | translate">{{'widget.bank-proposal.discover-opportunity' | translate}}</span>
      <span *ngIf="insitoAccountId === undefined" [title]="'widget.bank-proposal.discover-offers' | translate">{{'widget.bank-proposal.discover-offers' | translate}}</span>
    </a>
  </div>
</ng-container>
<ng-template #noData>
  <app-widget-message [message]="'widget.bank-proposal.no-data'| translate"
                      [widgetLabel]="'widget.name.'.concat(widget.widgetName) | translate"
                      [widgetSize]="widget.size"
                      icone="opt-stat"></app-widget-message>
</ng-template>

